import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useVisitId } from 'reservations/base/hooks/useQueryParams';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useFormattedBookingDetails } from 'reservations/booking/hooks/useFormattedBookingDetails';
import { useRemoveGuestMutation } from 'reservations/guests/queries/useRemoveGuestMutation';

export const LeavePartyModal = () => {
  const visitId = useVisitId();
  const { fullName } = useFormattedBookingDetails();
  const { close } = useModal();
  const removeGuestMutation = useRemoveGuestMutation(visitId, close);

  return (
    <BaseDrawer
      header="Leave party"
      subheader={`${fullName} will be notified if you do decide to leave the party.`}
      primaryButton={{
        label: 'LEAVE PARTY',
        variant: 'error',
        onClick: removeGuestMutation.mutate
      }}
      secondaryButton={{}}
      dataTestId="leave-party-modal"
      requireAuth
    />
  );
};
